module.exports = function(app) {

    app.factory('registration', ['services', '$q', '$state', '$window', '$filter', "$cookies", "teamsite", "brand", "coremetrics", "sessionData", "brandConfig", "$interval", "session", "appConfig", "storage",
        function(services, $q, $state, $window, $filter, $cookies, teamsite, brand, coremetrics, sessionData, brandConfig, $interval, session, appConfig, storage) {

            var chip14PGVerificationCounter = 0;
            var maxChip14PGVerificationAttempts = 3;
            var OauthMBH = sessionData.appConfig.ACCOUNT_SETTINGS &&
                sessionData.appConfig.ACCOUNT_SETTINGS.MFA_ENROLL_ELIGIBLE &&
                sessionData.appConfig.ACCOUNT_SETTINGS.MFA_ENROLL_ELIGIBLE.booleanValue == true;

            var handleSuccessResponse = function (response, user, defer) {
                var returnCode = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCode;
                var map = {
                    200: 'REGISTER_INVALID_BRAND',
                    221: 'DUP-REGISTERED',
                    222: 'REGISTER_LOOKS_FAMILIAR',
                    223: 'REGISTER_WRONG_SITE'
                };

                if  (returnCode === 200) {
                    // INVALID BRAND
                    if (response.data && response.data.payload && response.data.payload.brand === "INVALID") {
                        defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );
                    } else {
                        defer.resolve({ user: user, response: response.data.payload});
                    }
                } else if (returnCode === 222) {
                    // LOOKS FAMILIAR
                    //TODO: IF we don't implement visitor, this won't be needed.
                    //TODO: IF we do, this will be an alternate step injected into the registration flow (similar to CHIP14)
                    defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );

                } else if (returnCode === 224) {
                    // CHIP USER
                    user.isCHIP = true;
                    chip14PGVerificationCounter = 0;
                    defer.resolve({ user: user, response: response.data.payload});

                } else {
                    // For 221, 223, others...
                    defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );
                }
            };

            var handleErrorResponse = function (error) {
                var returnCode = (error  && error.data && error.data.baseMessage && error.data.baseMessage.returnCode) || 0;
                var returnCodeDescription = (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription) || null;

                if (returnCodeDescription === 'CHIP14_GUARDIAN_VERIFICATION_FAIL') {
                    // Increment the counter for allowable attempts at entering parent or guardian information for chip14 registration.
                    chip14PGVerificationCounter++;
                    if (chip14PGVerificationCounter >= maxChip14PGVerificationAttempts) {
                        returnCodeDescription = 'CHIP14_GUARDIAN_VERIFICATION_EXCEED';
                    }
                }
                return { returnCode: returnCode, returnCodeDescription: returnCodeDescription, chipCounter: chip14PGVerificationCounter };
            };

            var identifyUser = function(user) {
                var defer = $q.defer();

                services.rbsmbl.userIdentification().identify(user).then(
                    function(response) {
                        var returnCode = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCode;
                        var returnCodeDescription = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCodeDescription;
                        user.brand = response.data.payload.brand;

                        if (returnCode === 200) {
                            user.hasProfile = true;
                            response.data.payload.returnCode = returnCode;
                            response.data.payload.returnCodeDescription = returnCodeDescription;
                            defer.resolve( { user: user, response: response.data.payload } );
                        } else {
                            handleSuccessResponse(response, user, defer);
                        }
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var profile = function(user) {
                var defer = $q.defer();

                services.rbsmbl.consumerProfile().profile(user).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var register = function(user) {
                var defer = $q.defer();

                services.rbsmbl.registerUser().register(user).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var oldRegister = function(user, userType) {
                var defer = $q.defer();

                services.rbsmbl.oldRegister().register(user, userType).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };
            var hostnameArray = window.location.hostname.split('.');
            var subDomain = hostnameArray[0],
                brandDomain= hostnameArray[1];
            var oAuthMfaRedirect = function(){

                var environmentConfigs =
                {
                    highmarkbcbs:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '526f617-04d5-64b5-84a637376414845716c44304755673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '64302b7-7724-2736-4737239755430515a2f61596e6a413d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkbcbswv:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '4e52355-96a5-8304-462456e435569577a6971414633673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '71774c4-54d7-a4c7-341726556344b44416549424f79773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkbcbsde:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '69326d6-8496-2726-c57726271676b74745a4b6f3975673d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '5463576-76e7-8417-26b307a59797949553179563374773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    highmarkblueshield:{
                        test: {
                            environmentType: 'test.auth',
                            client_id: '4d704e6-b435-86c6-e495849576e4f335a496d345976413d3d'

                        },
                        prod: {
                            environmentType: 'auth',
                            client_id: '4533796-b4e3-4437-5596861317445544738444f4137773d3d'
                        },
                        domain:'legacy-portal-apps-domain'

                    },
                    mybenefitshome:{
                        test:{
                            environmentType:"https://test.auth.allmyhealth.com/oauth2/rest/authz?",
                            client_id:"39597a4-4426-a2b4-f4c693846585557786c37533164773d3d"
                        },
                        prod: {
                            environmentType: "https://auth.allmyhealth.com/oauth2/rest/authz?",
                            client_id: '466f623-0544-44b6-3565242546e4262544439694162413d3d'
                        },
                        domain:'allmyhealth'
                    },
                    yourwyoblue:{
                        test:{
                            environmentType:"https://test.auth.yourwyoblue.com/oauth2/rest/authz?",
                            client_id:"31736a3-6616-f543-97241454a722b45706e4a397758773d3d"
                        },
                        prod: {
                            environmentType: "https://auth.yourwyoblue.com/oauth2/rest/authz?",
                            client_id: '6465306-1557-8757-a446e47732f4665794b30502f51513d3d'
                        },
                        domain:'MemberWY'
                    }



                };



                if(environmentConfigs[brandDomain])var currentConfig = subDomain == 'www' || subDomain == 'penv' ?  environmentConfigs[brandDomain].prod:environmentConfigs[brandDomain].test ;

                var
                    oamAuthorizeRoot = brandDomain=="mybenefitshome"  || brandDomain=="yourwyoblue" ? currentConfig.environmentType:'https://'+currentConfig.environmentType+".highmark.com/oauth2/rest/authz?",
                    redirectUri = "https://"+window.location.hostname+"/login/#/loggingIn",


                    params = [
                        "response_type=code",
                        "client_id=" + currentConfig.client_id,
                        "scope=resource.READ",
                        "domain="+environmentConfigs[brandDomain].domain,
                        "redirect_uri=" + encodeURIComponent(redirectUri)
                    ];
                window.location.href = oamAuthorizeRoot + params.join('&');

            };
            var oauthLogin = function(){
                switch (brandDomain) {

                    case "highmarkbcbs":

                    case "highmarkblueshield":

                    case "highmarkbcbsde":

                    case "highmarkbcbswv":
                    case "yourwyoblue":

                        return true;
                        break;


                    default:
                        return false;
                        break;
                }
            };
            var doLogin = function(user, campaignID, userType) {
                var defer = $q.defer();

                services.rbsmbl.loginversion().fetch(user.username).then(function(response) {
                    if (response && response.data && response.data.payload && response.data.payload.loginVersion === 'MER_LOGIN_V1') {

                        var password = response.data.payload.convertCase ? user.password.toUpperCase() : user.password;
                        if(oauthLogin()|| OauthMBH){
                            oAuthMfaRedirect();
                        }else {
                            services.rbsmbl.login().loginWithRedirect(user.username, password, 'loginRedirectCampaign', 'landing').then(function (loginResponse) {

                                if (campaignID && campaignID.length > 0) {
                                    $state.go('campaignLogin', {id: campaignID});
                                } else {
                                    if (userType && userType == 'medicareMember') {
                                        $window.location.href = "/#" + $state.params.originalUrl;
                                    } else if (brand.current.sharedBrandCode === "mincr") {
                                        $window.location.href = '/member/home';
                                    } else {
                                        $window.location.href = '/mbr/#!/landing';
                                    }
                                }
                                defer.resolve(loginResponse);

                            }, function (error) {
                                defer.reject(error);
                            });
                        }
                    } else {
                        defer.reject('Unsupported login version');
                    }

                }, function(error) {
                    defer.reject(error);
                });
                return defer.promise;
            };

            var loginShop = function(user) {
                var defer = $q.defer();
                
                services
                    .rbsmbl
                    .userLogin()
                    .fetch(user.username, user.verifiedPassword)
                    .then(function(response){
                        var loginData = response.data;
                        brand.override = brand.override || loginData.regions[0].brand;

                        brandConfig.update();

                        defer.resolve(response);
                        services.rbsmbl.userLogin().setDDToken();
                        services.rbsmbl.userLogin().appendToSessionData(loginData);
                    },
                    function(error){
                        defer.reject(error);
                    });

                return defer.promise;
            };

            var notificationFilter = function(type, stateName) {
                return function(item) {
                    var states = item.states && item.states.length > 0 ? item.states.split(',') : [];
                    return item &&
                        item.sections &&
                        item.sections.memberRegistration &&
                        (item.type === type) &&
                        (stateName && stateName.length === 0 ||
                            (states.length === 0 || states.indexOf(stateName) >= 0) );
                };
            };

            var navigationFilter = function(isVisitor) {
                return function(item) {
                    return item && item.sections && (item.sections.memberRegistration || (isVisitor && item.sections.visitorRegistration));
                };
            };

            return {
                identifyUser: identifyUser,
                profile: profile,
                register: register,
                oldRegister: oldRegister,
                loginMember: doLogin,
                loginShop: loginShop,
                notificationFilter: notificationFilter,
                navigationFilter: navigationFilter,
                notifications: {
                    verifyPleaseWait: 'REGISTER_VERIFY_PLEASE_WAIT',
                    registerPleaseWait: 'REGISTER_PLEASE_WAIT',
                    loginPleaseWait: 'REGISTER_LOGIN_PLEASE_WAIT',
                    registerPassLoginFail: 'REGISTER_SUCCESS_LOGIN_FAIL',
                    memberNotOnPlatform: 'REGISTER_UNION_PACIFIC_MESSAGE',
                    chsMemberLoginFail: 'REGISTER_CHS_CLIENT_LOGIN_FAIL',
                    selectMedMemberLoginFail: 'REGISTER_SELECT_MED_LOGIN_FAIL',
                    defaultError: 'REGISTER_DEFAULT_NOTIFICATION'
                }
            };
        }
    ]);
};
